// The API sends a string message for 400/403/409, but a 422 sends
// class-validator ValidationError[]: default messages are i18n keys
// ('error.fields.is_uuid') and nested DTO errors keep their constraints on
// children. Passing that array to toast.error crashes React, so always
// reduce it to text here.
export const apiErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message
  if (!Array.isArray(msg)) return typeof msg === 'string' && msg ? msg : fallback

  const reasons = new Set()
  const walk = (errors, path) => errors.forEach((e) => {
    if (typeof e === 'string') return reasons.add(e)
    const field = path ? `${path}.${e?.property}` : e?.property
    Object.values(e?.constraints || {}).forEach((text) => {
      reasons.add(text && !text.startsWith('error.fields.') ? text : `${field} is invalid`)
    })
    walk(e?.children || [], field)
  })
  walk(msg, '')
  return [...reasons].join('; ') || fallback
}
